import {
  CompassAPIMultiSeriesChartData,
  getCompassAPIChartData,
  getMultipleLineChartProps,
} from '../utils/compass'
import { CommonChartConfig } from './common'
import type { BaseContext } from './'

export namespace Industrials {
  export namespace Valuation {
    const CONTEXT_ID = 'equity:industrials:valuation'

    export const __typelist: {
      config: ChartConfig
      data: ChartData
      context: ContextType
    } = {} as any

    export type ContextType = BaseContext<
      typeof CONTEXT_ID,
      ChartConfig,
      ChartData
    >

    export interface ChartConfig extends CommonChartConfig {
      chart:
        | 'pe_embr3'
        | 'pe_pomo4'
        | 'pe_leve3'
        | 'pe_mypk3'
        | 'pe_rapt3'
        | 'pe_wege3'
        | 'pe_siegy_us'
        | 'pe_abb_us'
        | 'pe_tsla_us'
        | 'pe_aeri3'
        | 'pe_tpic_us'
        | 'pe_ambp3'
        | 'pe_vow3_gy'

      context: typeof CONTEXT_ID
    }

    export type ChartData = CompassAPIMultiSeriesChartData

    export const Context: ContextType = {
      id: CONTEXT_ID,
      getChartId: (config) => `${config.context}:${config.chart}`,
      getChartData: getCompassAPIChartData,
      getChartProps: (config, data) => getChartProps(config, data),
    }

    const getChartProps = (
      config: ChartConfig,
      data: CompassAPIMultiSeriesChartData
    ) =>
      getMultipleLineChartProps(
        Context,
        {
          addMinMaxIndicators: true,
          msdIndicators: { avg: true, sd1: true, sd2: true },
        },
        { name: [''] }
      )(config, data)
  }
}
